import React from 'react';
import { registerUser } from '../../react-cognito';
import { connect } from 'react-redux';
import store from '../../store'
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import history from '../../history';
import { createSignupUser } from '../../actions/user';
import { createPetShop, getPetShopByDomain, checkPetshopAndUser } from '../../actions/petShop'
import { setDefaultConfig } from '../../actions/configuration';
import Select from 'react-select';
import PhoneInput from 'react-phone-number-input';
import "react-phone-number-input/style.css";

let form_step_1 = {};
class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStepNotValid:false,
            name: '',
            username: '',
            email: '',
            password: '',
            retypePassword: '',
            loading: false,
            captchaSuccess: false,
            nextStep: false,
            title: '',
            phone_number: '',
            first_name: '',
            last_name: '',
            country: '',
            domain: '',
            payments: [{method: 'cash', card_type: 'visa', amount: 0}],
        };
    }

    nextStep = () => {
        const regXmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const regXpass = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        var cont = true;
        if (!this.state.email.match(regXmail)) {
            NotificationManager.error("Email address not valid!");
            cont = false;
        }
        if (!regXpass.test(this.state.password)) {
            NotificationManager.error("Password should contain more than 8 characters with at least one uppecase character,one lowercase character and a number!");
            cont = false;
        }
        if (this.state.password !== this.state.retypePassword) {
            NotificationManager.error("Passwords do not match!");
            cont = false;
        }
        if (cont) {
            this.setState({
                nextStep: true
            })
        }
    }

    prevStep = () => {
        this.setState({
            nextStep: false
        })
    }
    onSubmit = (event) => {
        event.preventDefault();
        if(this.validateForm()){
            let data = Object.values(form_step_1).map(key=>{
                if(key!==null) {
                    return true;
                }
                else{
                    return false;
                }
            });

            if(!data.includes(false)){
                if(this.state.domain.trim().length >= 4) {
                    if(this.state.email && this.state.username)
                        this.props.checkPetshopAndUser(this.state.domain, this.state.username, this.state.email);
                } else {
                    NotificationManager.error('Domain name must be atleast 4 characters');
                }
            }
            else{
                this.setState({currentStepNotValid: true});
                //this.setState({loading: false});
                NotificationManager.warning("Please check input details again.");  
            }
        }
    }
    validateForm =()=>{
        const data = {
            title:this.state.title.trim().length>0? this.state.title:null,
            first_name:this.state.first_name.trim().length>0? this.state.first_name:null,
            last_name:this.state.last_name.trim().length>0? this.state.last_name:null,
            country:this.state.country.trim().length>0? this.state.country:null
        };
        form_step_1 = Object.assign({},data);
        return true;
        
    }
    changeName = (event) => {
        this.setState({ name: event.target.value });
    }

    changeEmail = (event) => {
        this.setState({ email: event.target.value });
    }

    changePassword = (event) => {
        this.setState({ password: event.target.value });
    }

    changeRetypePassword = (event) => {
        this.setState({ retypePassword: event.target.value });
    }

    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    changeCountry = (event) => {
        this.setState({country: event.value})
    }
    // componentDidMount = () =>{
    //     this.setState({country:this.props.petShop.currentPetshop.country})
    // }
    componentWillReceiveProps = (nextProps) => {
        if(nextProps.currentPetshop && this.props.currentPetshop !== nextProps.currentPetshop) {
            this.setState({country:nextProps.currentPetshop.country})
        }
        if(this.props.newPetshop !== nextProps.newPetshop && nextProps.newPetshop) {
            NotificationManager.success("Pet store created successfully");
            // this.props.setDefaultConfig();
            window.location.replace("https://"+this.state.domain+".petpos.com/login");
        }
        if(this.props.petShop.setPetShopError !== nextProps.petShop.setPetShopError && nextProps.petShop.setPetShopError) {
            NotificationManager.error("Something went wrong");
        }

        if(nextProps.petShop.petShopNUser && this.props.petShop.petShopNUser !== nextProps.petShop.petShopNUser) {
            if(nextProps.petShop.petShopNUser.error) {
                NotificationManager.error(nextProps.petShop.petShopNUser.msg);
            }

            if(!nextProps.petShop.petShopNUser.error) {
                const userPool = this.props.userPool;
                const config = this.props.config;
                const username = this.state.username;
                this.setState({ loading: true })
                const userAttr = {
                    email: this.state.email
                }
                registerUser(userPool, config, username, this.state.password, {
                    email: this.state.email
                }).then(
                    (action) => {
                        this.setState({ loading: false })
                        store.dispatch(action);
                        if (this.props.cognitoState === 'USER_REGISTERED') {
                            userAttr.user_sub = this.props.userSub;
                            userAttr.congnito_id = this.props.userSub;
                            userAttr.username = this.props.createdUser.username;
                            userAttr.domain_name = this.state.domain
                            this.props.createSignupUser(userAttr);
                                
                        }
                        
                    },
                    error => {
                        this.setState({ loading: false })
                        NotificationManager.error(error);
                    }
                );
            }
            
        }

        if(nextProps.petShop.petShopNUser && nextProps.petShop.petShopNUser === 'Proceed' && this.props.petShop.petShopNUser !== nextProps.petShop.petShopNUser) {
            
        }

        if(this.props.newUser !== nextProps.newUser) {
            NotificationManager.success("User Account Created Successfully");
            const store = {
                title: this.state.title,
                email: this.state.email,
                phone_number: this.state.phone_number,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                country: this.state.country,
                domain: this.state.domain,
                userId: this.props.userSub
            }
        
            this.props.createPetstore(store);
        }
    }

    render() {
        
        const { title, email, phone_number, first_name, last_name, country, domain } = this.state;

        return (
        <div className="m-grid m-grid--hor m-grid--root m-page">
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2" id="m_login" style={{ backgroundImage: "url(../../../assets/app/media/img/bg/new-background.png)"}}>
                <div className="m-grid__item m-grid__item--fluid	m-login__wrapper">
                    <div className="m-login__container">
                        <div className="m-login__logo">
                            <a href="#">
                                <img src="../../../assets/app/media/img/logos/petpos-logo2.png" style={{width: '230px'}}/>
                            </a>
                        </div>
                        <div className="m-login__signin">

                                <div className="m-login__head">

                                    {this.state.nextStep == false?
                                        <h3 className="m-login__title">
                                            Register Your Account
                                        </h3>:
                                        <h3 className="m-login__title">
                                            Create Pet Store
                                        </h3>
                                    }
                                  
                                </div>
                            {this.state.nextStep == false?
                                <div className="m-login__form m-form" noValidate autoComplete="off">
                                    {/* <div className="form-group m-form__group">
                                        <input  value={this.state.name} onChange={this.changeName} className="form-control m-input" type="text" placeholder="Full Name" name="name" autocomplete="off"/>
                                    </div> */}
                                    <div className="form-group m-form__group">
                                        <input  value={this.state.email} onChange={this.changeVal} className="form-control m-input" type="text" placeholder="Email" name="email" autocomplete="off"/>
                                    </div>
                                    <div className="form-group m-form__group">
                                        <input  value={this.state.username} onChange={this.changeVal} className="form-control m-input" type="text" placeholder="Username" name="username" autocomplete="off"/>
                                    </div>
                                    <div className="form-group m-form__group">
                                        <input autoComplete="current-password" onChange={this.changePassword} className="form-control m-input m-login__form-input--last" type="password" placeholder="Password" name="password"/>
                                    </div>
                                    <div className="form-group m-form__group">
                                        <input autoComplete="Retype-password" onChange={this.changeRetypePassword} className="form-control m-input m-login__form-input--last" type="password" placeholder="Retype Password" name="retypePassword"/>
                                    </div>
                                    
                                    <div className="m-login__form-action">
                                    
                                        <button onClick={this.nextStep} id="m_login_signin_submit" className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air  m-login__btn">
                                            Continue
                                        </button>

                                    </div>
                                </div> :
                                <form onSubmit={this.onSubmit} className="m-form m-form--fit m-form--label-align-right">
                                <div className="m-portlet__body" style={{backgroundColor: "white"}}>
                                    <div className="form-group m-form__group m--margin-top-10">
                                    <div className="alert m-alert m-alert--default" role="alert">
                                        Please fill this form
                                    </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                    <label for="text-input" className="col-3 col-form-label">Shop Name</label>
                                    <div className="col-9">
                                        <input className="form-control m-input" type="text" value="Title" id="text-input"  onChange={this.changeVal} name="title" value={title}/>
                                        <span className={form_step_1.title===null&&this.state.currentStepNotValid?'m-form__help_danger':'m-form__help'}>Enter the pet shop name</span>
                                    </div>
                                    </div>
                                    {/* <div className="form-group m-form__group row">
                                    <label for="email-input" className="col-3 col-form-label">Email</label>
                                    <div className="col-9">
                                        <input className="form-control m-input" type="email" value="Enter your email address" id="email-input"  onChange={this.changeVal} name="email" value={email}/>
                                    </div>
                                    </div> */}
                                    <div className="form-group m-form__group row">
                                        <label for="text-input" className="col-3 col-form-label">First Name</label>
                                        <div className="col-9">
                                            <input className="form-control m-input" type="text" value="Enter your first name" id="text-input"  onChange={this.changeVal} name="first_name" value={first_name}/>
                                            <span className={form_step_1.first_name===null&&this.state.currentStepNotValid?'m-form__help_danger':'m-form__help'}>Enter your frist name</span>
                                        </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                        <label for="text-input" className="col-3 col-form-label">Last Name</label>
                                        <div className="col-9">
                                            <input className="form-control m-input" type="text" value="Enter your last name" id="text-input"  onChange={this.changeVal} name="last_name" value={last_name}/>
                                            <span className={form_step_1.last_name===null&&this.state.currentStepNotValid?'m-form__help_danger':'m-form__help'}>Enter your last name</span>
                                        </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                        <label for="text-input" className="col-3 col-form-label">Country</label>
                                        <div className="col-9">
                                            <Select options={[
                                                { value: 'US', label: 'United States' },
                                                { value: 'GB', label: 'United Kindom' },
                                                { value: 'LK', label: 'Sri Lanka' }

                                            ]} value={country} onChange={this.changeCountry} placeholder="Select your country"/>
                                            <span className={form_step_1.country===null&&this.state.currentStepNotValid?'m-form__help_danger':'m-form__help'}>Select your country</span>
                                        </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                    <label for="text-input" className="col-3 col-form-label">Select Domain</label>
                                    <div className="col-9">
                                        <div className="input-group">
                                            <input type="text" className="form-control m-input" placeholder="Enter your domain" id="text-input"  onChange={this.changeVal} name="domain" value={domain} aria-describedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">.petpos.com</span>
                                            </div>
                                        </div>
                                        {/* <span className={form_step_1.domain===null&&this.state.currentStepNotValid?'m-form__help_danger':'m-form__help'}>Select domain name for your pet shop</span> */}
                                        {/* <input className="form-control m-input" type="text" value="Enter your domain" id="text-input"  onChange={this.changeVal} name="domain" value={domain}/> */}
                                    </div>
                                    </div>
                                    {/* <div className="form-group m-form__group row">
                                        <label className="col-3 col-form-label">Upload Your File</label>
                                        <div className="col-9">
                                            <div className="m-dropzone dropzone dz-clickable" action="inc/api/dropzone/upload.php" id="m-dropzone-one">
                                                <div className="m-dropzone__msg dz-message needsclick">
                                                    <h3 className="m-dropzone__msg-title">Drop files here or click to upload.</h3>
                                                    <span className="m-dropzone__msg-desc">This is just a demo dropzone. Selected files are <strong>not</strong> actually uploaded.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="m-portlet__foot m-portlet__foot--fit">
                                <div className="m-login__form-action">
                                <div className="row">
                                    <div className="col-12">
                                        <button type="submit" onClick={this.onSubmit} id="m_login_signin_submit" className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air  m-login__btn pull-right ml-2">
                                            Submit
                                        </button>
                                        <button type="submit" onClick={this.prevStep} id="m_login_signup" className="btn btn-outline-focus m-btn--pill pull-right">
                                            Back
                                        </button>
                                        
                                        {/* <button type="submit" className="btn m-btn--pill btn-success pull-right" onClick={this.onSubmit}>Submit</button> */}
                                    </div>
                                </div>
                                </div>
                            </div>
                            </form>
                        
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        config: state.cognito.config,
        cognitoState: state.cognito.state,
        userPool: state.cognito.userPool,
        createdUser: state.cognito.newUser,
        userSub: state.cognito.userSub,
        newPetshop: state.petShopReducer.setPetShop,
        currentPetshop: state.petShopReducer.currentPetshop,
        petShop: state.petShopReducer,
        newUser: state.userReducer.newUser,
    };
};

const mapDispatchToProps = dispatch => ({
    createSignupUser: (user) => {
      dispatch(createSignupUser(user));
    },
    createPetstore: (attrs) => {
        dispatch(createPetShop(attrs));
    },
    getPetShopByDomain: (domain) => {
        dispatch(getPetShopByDomain(domain));
    },
    setDefaultConfig: () => {
        dispatch(setDefaultConfig());
    },
    checkPetshopAndUser: (domain, un, email) => {
        dispatch(checkPetshopAndUser(domain, un, email));
    },
})

export default connect(
    mapStateToProps,mapDispatchToProps
)(Register);

